import { APIClient } from "../../../helpers/api_helper";

const api = new APIClient();

  export const createMaterial = async (data) => {
    try {
      const response = await api.create(`/materials/add`, data);
      return response;
    } catch (error) {
      throw error;
    }
  };

  export const getMateriels = async () => {
    try {
      const response = await api.get(`/materials/all`);
      return response;
    } catch (error) {
      throw error;
    }
  };

  export const updateMaterial = async ( id, data) => {
      try {
        const response = await api.put(`/materials/update/${id}`, data);
        return response;
      } catch (error) {
        throw error;
      }
  };

  export const deleteMaterial = async (id) => {
    try {
        const response = await api.delete(`/materials/delete/${id}`);
        return response;
    } catch (error) {
        throw error;
    }
  };

  export const assignMaterial = async (data) => {
    try {
        const response = await api.put(`/request-assignment/assign/${data?.intervenantId}/request/${data?.materialRequestId}`, data);
        return response;
    } catch (error) {
        throw error;
    }
  };

  export const clotureDemande = async (id) => {
    try {
        const response = await api.put(`/material-requests/updateStatus/${id}`, {status: "CLOTURE"});
        return response;
    } catch (error) {
        throw error;
    }
  };
